 const DateAndTimeWrapperComponent = ({children}) => {
   return (
       <div className={"container"}>
           <div className="px-4 py-3 rounded bg-white mb-3 col-lg-8 mx-auto">
               {children}
           </div>
       </div>
   )
 }
 export default DateAndTimeWrapperComponent;